import React from "react";
import { Container, Card, Row, Col, Button, ListGroup } from "react-bootstrap";

function Corporate({ account_details }) {
  return (
    <div>
      <div className="mb-4">
        <Card
          style={{
            // backgroundColor: "#E4F1F7",
            padding: "4px", // Reduced padding
            fontSize: "0.9rem", // Adjusted font size for compactness
          }}
          className="border border-primary h-100"
        >
          <Card.Body style={{ padding: "0px" }}>
            <Row
              className="d-flex justify-content-between"
              style={{ marginBottom: "8px" }}
            >
              <Col>
                <Card.Title
                  style={{ fontSize: "1.2rem", paddingLeft: "0.4rem" }}
                >
                  {account_details?.[0]?.account_type}
                </Card.Title>
              </Col>
              <Col className="text-end">
                <Button
                  size="sm"
                  style={{
                    fontSize: "0.8rem",
                    backgroundColor: "var(--primary-color)",
                    border: 0,
                  }}
                >
                  {account_details?.[0]?.status}
                </Button>
              </Col>
            </Row>
            <Row>
              <Col>
                <Card.Text
                  style={{ fontSize: "0.9rem", paddingLeft: "0.4rem" }}
                >
                  {account_details?.[0]?.account}
                </Card.Text>
              </Col>
            </Row>
            <Row>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{
                      border: "none",
                      backgroundColor: "transparent",
                    }}
                    className="pl-2"
                  >
                    <strong>Loan Type :</strong>
                  </ListGroup.Item>
                </ListGroup>
              </Col>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{
                      border: "none",
                      backgroundColor: "transparent",
                    }}
                    className="pl-2"
                  >
                    <strong>Last Pay. Date :</strong>
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{
                      border: "none",
                      backgroundColor: "transparent",
                    }}
                    className="pl-2"
                  >
                    {account_details?.[0]?.loan_type}
                  </ListGroup.Item>
                </ListGroup>
              </Col>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{
                      border: "none",
                      backgroundColor: "transparent",
                    }}
                    className="pl-2"
                  >
                    {account_details?.[0]?.last_payment_activity || ""}
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{
                      border: "none",
                      backgroundColor: "transparent",
                    }}
                    className="pl-2"
                  >
                    <strong>Closing Date :</strong>
                  </ListGroup.Item>
                </ListGroup>
              </Col>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{
                      border: "none",
                      backgroundColor: "transparent",
                    }}
                    className="pl-2"
                  >
                    <strong>Maturity :</strong>
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{
                      border: "none",
                      backgroundColor: "transparent",
                    }}
                    className="pl-2"
                  >
                    {account_details?.[0]?.closing_date}
                  </ListGroup.Item>
                </ListGroup>
              </Col>
              <Col>
                <ListGroup className="list-group-no-border">
                  <ListGroup.Item
                    style={{
                      border: "none",
                      backgroundColor: "transparent",
                    }}
                    className="pl-2"
                  >
                    {account_details?.[0]?.maturity}
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </Row>
            <Col>
              {/* <Row>
                <Card.Link
                  href="#"
                  style={{
                    textDecoration: "none",
                    fontSize: "0.9rem",
                    margin: "1rem 0",
                    paddingLeft: "0.7rem",
                  }}
                >
                  Renegotiate Loan
                </Card.Link>
              </Row> */}
            </Col>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}

export default Corporate;
